import React from 'react';
import { Fade, Zoom } from 'react-awesome-reveal';
import { FaFacebookF, FaTwitter, FaInstagram } from 'react-icons/fa';

const TeamSection = () => {
  const teamMembers = [
    { 
      id: 1, 
      initials: 'SS', 
      name: 'Ms. SHYMA', 
      designation: 'SENIOR DESIGNER',
      delay: 100
    },
    { 
      id: 2, 
      initials: 'RR', 
      name: 'Mr. RANEES', 
      designation: 'GENERAL MANAGER',
      delay: 300
    },
    { 
      id: 3, 
      initials: 'SS', 
      name: 'Ms. SHAHANA SHERIN', 
      designation: 'ADMIN MANAGER',
      delay: 500
    },
  ];

  return (
    <div className="container-xxl py-6">
      <div className="container">
        <Fade triggerOnce>
          <div className="text-center mx-auto mb-5" style={{ maxWidth: '500px' }}>
            <p className="text-primarys text-uppercase mb-2">// Our Team</p>
            <h1 className="display-6 mb-4">We're Super Professional At Our Skills</h1>
          </div>
        </Fade>
        <div className="row g-4">
          {teamMembers.map((member) => (
            <div key={member.id} className="col-lg-4 col-md-6">
              <Zoom delay={member.delay} triggerOnce>
                <div className="team-card-modern text-center rounded overflow-hidden">
                  {/* Initials Avatar */}
                  <div className="team-avatar bg-primarys d-flex align-items-center justify-content-center mx-auto mb-4">
                    <span className="display-5 fw-bold text-white">{member.initials}</span>
                  </div>
                  
                  {/* Team Info */}
                  <div className="team-info px-3">
                    <h5 className="mb-1">{member.name}</h5>
                    <p className="text-primarys mb-3 fw-bold">{member.designation}</p>
                    
                    {/* Social Links */}
                    <div className="team-social mt-3">
                      <a className="btn btn-square btn-light rounded-circle mx-1" href="https://facebook.com" target="_blank" rel="noopener noreferrer">
                        <FaFacebookF />
                      </a>
                      <a className="btn btn-square btn-light rounded-circle mx-1" href="https://twitter.com" target="_blank" rel="noopener noreferrer">
                        <FaTwitter />
                      </a>
                      <a className="btn btn-square btn-light rounded-circle mx-1" href="https://instagram.com" target="_blank" rel="noopener noreferrer">
                        <FaInstagram />
                      </a>
                    </div>
                  </div>
                </div>
              </Zoom>
            </div>
          ))}
        </div>
      </div>
      
      <style jsx>{`
        .team-card-modern {
          background: #fff;
          padding: 2.5rem 1.5rem;
          box-shadow: 0 5px 25px rgba(98, 129, 65, 0.1);
          border: 1px solid rgba(98, 129, 65, 0.1);
          transition: all 0.3s ease;
          height: 100%;
        }
        
        .team-card-modern:hover {
          transform: translateY(-10px);
          box-shadow: 0 15px 35px rgba(98, 129, 65, 0.15);
          border-color: rgba(98, 129, 65, 0.2);
        }
        
        .team-avatar {
          width: 120px;
          height: 120px;
          border-radius: 50%;
          background: linear-gradient(135deg, #628141, #8BAE66);
          position: relative;
          overflow: hidden;
          transition: all 0.3s ease;
        }
        
        .team-card-modern:hover .team-avatar {
          transform: scale(1.05);
          box-shadow: 0 10px 25px rgba(98, 129, 65, 0.3);
        }
        
        .team-avatar::before {
          content: '';
          position: absolute;
          top: -50%;
          left: -50%;
          width: 200%;
          height: 200%;
          background: radial-gradient(circle, rgba(255,255,255,0.2) 0%, transparent 70%);
          opacity: 0;
          transition: opacity 0.3s ease;
        }
        
        .team-card-modern:hover .team-avatar::before {
          opacity: 1;
        }
        
        .team-info h5 {
          color: #1B211A;
          font-weight: 600;
        }
        
        .team-social .btn {
          width: 40px;
          height: 40px;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          background: #F8FAFC;
          border: 1px solid #E2E8F0;
          color: #628141;
          transition: all 0.3s ease;
        }
        
        .team-social .btn:hover {
          background: #628141;
          border-color: #628141;
          color: white;
          transform: translateY(-3px);
        }
        
        /* Responsive adjustments */
        @media (max-width: 768px) {
          .team-avatar {
            width: 100px;
            height: 100px;
          }
          
          .team-avatar span {
            font-size: 2rem;
          }
          
          .team-card-modern {
            padding: 2rem 1rem;
          }
        }
      `}</style>
    </div>
  );
};

export default TeamSection;

